import {
  forwardRef,
  type InputHTMLAttributes,
  type TextareaHTMLAttributes,
} from "react";
import { cn } from "@/lib/cn";

type FieldVariant = "default" | "mono";

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  variant?: FieldVariant;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, variant = "default", ...props }, ref) => (
    <input
      ref={ref}
      className={cn(
        "h-9 w-full bg-surface-2 text-text-primary placeholder:text-text-muted",
        "border border-border rounded-md px-3 text-sm",
        "transition-shadow duration-150",
        "focus:outline-none focus:border-magenta focus:shadow-focus",
        "disabled:opacity-50 disabled:cursor-not-allowed",
        variant === "mono" ? "font-mono" : "font-sans",
        className,
      )}
      {...props}
    />
  ),
);
Input.displayName = "Input";

interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  variant?: FieldVariant;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, variant = "default", ...props }, ref) => (
    <textarea
      ref={ref}
      className={cn(
        "w-full bg-surface-2 text-text-primary placeholder:text-text-muted resize-none",
        "border border-border rounded-md px-3 py-2 text-sm",
        "transition-shadow duration-150",
        "focus:outline-none focus:border-magenta focus:shadow-focus",
        "disabled:opacity-50 disabled:cursor-not-allowed",
        variant === "mono" ? "font-mono" : "font-sans",
        className,
      )}
      {...props}
    />
  ),
);
Textarea.displayName = "Textarea";
